import Link from 'next/link'
import React from 'react'
import { Text, TextTypes } from '../../..'

interface Props {
    href: string
    isActive?: boolean
    icon?: React.ReactNode
    badge?: React.ReactNode
    children: React.ReactNode
    className?: string
}

export const NavigationListItemLink = React.forwardRef<HTMLAnchorElement, Props>(
    ({ href, isActive = false, icon, badge, children, className = '', ...props }, ref) => {
        return (
            <Link
                ref={ref}
                href={href}
                className={`flex items-center gap-3 py-3 pl-3 pr-1 font-medium w-full text-inherit focus:outline focus:outline-accent-700 ${className}`}
                {...props}
            >
                {icon && <span className="shrink-0">{icon}</span>}
                <Text type={TextTypes.PARAGRAPH} tag="span">
                    {children}
                </Text>
                {badge && <span className="shrink-0 ml-auto">{badge}</span>}
            </Link>
        )
    },
)

NavigationListItemLink.displayName = 'NavigationListItemLink'
